import { appServe } from "@/service"
import { defineStore } from "pinia"
import { ID_TOKEN_KEY, ID_KEY, RC_ID_KEY } from "@/common/config"
import { getWithExpiry, saveToken, destroyToken } from "@dg/utils"
import router from "@/router"
import { isZWEnv } from "@/utils"
import { isNew } from "@/common/config"

const useSaveToken = (token) => {
  if (token) {
    if (isNew) {
      const [, config] = token.split(".")
      const { exp } = JSON.parse(atob(config)) // 超时秒数
      saveToken(ID_TOKEN_KEY, token, exp * 1000 - 60000)
    } else {
      saveToken(ID_TOKEN_KEY, token, 14160000)
    }
  }
}

export const useAppStore = defineStore("app", {
  state: () => ({
    uiStyle: "normal", // 适老化样式控制
    token: getWithExpiry(ID_TOKEN_KEY)?.value, // 用户 token
    cachedViews: [], // 缓存页面
    // 校友录信息
    rcId: sessionStorage.getItem(RC_ID_KEY) || "", // 用户 uuid
    id: sessionStorage.getItem(ID_KEY) || "", // 校友录用户 id
    userInfo: sessionStorage.getItem("userInfo") || {}, // 用户信息
    userType: sessionStorage.getItem("userType") || "personnel", // 用户类型
    fileCacheList: {}, // 附件缓存
    areaId: 1, //地区id
    merchantId: null //记录商家经办人查看的商家id
  }),
  getters: {
    // 判断用户是否已登录
    isLogged(state) {
      const { token } = state
      return !!token
    },
    isLegal(state) {
      const { userType } = state
      return userType === "legal"
    },
    isElder(state) {
      return state.uiStyle === "elder"
    }
  },
  actions: {
    addCachedView(name) {
      if (!this.cachedViews.includes(name)) {
        this.cachedViews.push(name)
      }
    },
    delCachedView(name) {
      if (typeof name === "string") {
        if (this.cachedViews.includes(name)) {
          this.cachedViews.splice(this.cachedViews.indexOf(name), 1)
        }
      } else if (name instanceof Array) {
        name.forEach((v) => {
          if (this.cachedViews.includes(v)) {
            this.cachedViews.splice(this.cachedViews.indexOf(v), 1)
          }
        })
      } else {
        this.cachedViews = ["BaseLayouts"]
      }
    },
    // 覆写登录相关数据
    saveLoginKey({ token, rcId, type }) {
      const { token: storeToken, rcId: storeRcId, userType } = this
      const defaultToken = token || storeToken || getWithExpiry(ID_TOKEN_KEY)
      if (defaultToken) {
        useSaveToken(defaultToken)
        this.token = defaultToken
      }
      const defaultRcId = rcId || storeRcId || sessionStorage.getItem(RC_ID_KEY)
      if (defaultRcId) {
        sessionStorage.setItem(RC_ID_KEY, defaultRcId)
        this.rcId = defaultRcId
      }
      const defaultType = type || userType || sessionStorage.getItem("userType")
      if (defaultType) {
        sessionStorage.setItem("userType", defaultType)
        this.userType = defaultType
      }
    },
    logout() {
      destroyToken(ID_TOKEN_KEY)
      this.token = null
      sessionStorage.removeItem(RC_ID_KEY)
      sessionStorage.removeItem("userType")
      sessionStorage.removeItem("userInfo")
      this.id = null
      this.userInfo = null
    },
    // 校友录获取用户信息
    async getUserInfo() {
      if (this.rcId) {
        const res = await appServe.getRcYunUserInfoByRcId(this.rcId)
        if (res.success) {
          sessionStorage.setItem(ID_KEY, res.data.id)
          sessionStorage.setItem("userInfo", res.data)
          this.id = res.data.id
          this.userInfo = res.data
        } else {
          if (res.data.message === "尚未加入同学录，请填写资料加入") {
            sessionStorage.removeItem(ID_KEY)
            this.id = ""
            router.replace("/alumni/info")
          }
        }
      } else {
        //toLogin()
      }
    },
    /* ================================= */
    // 缓存附件
    cacheFile(data) {
      const { file, uuid, name } = data
      const names = name.split(".")
      const ext = names[names.length - 1]?.toLowerCase()
      const imgExts = ["png", "jpeg", "jpg"]
      const videoExts = [
        "mp4",
        "3gp",
        "avi",
        "mov",
        "hevc",
        "wmv",
        "flv",
        "mkv",
        "rmvb",
        "mpeg",
        "mpg"
      ]
      const config = {
        ...data,
        isImage: imgExts.includes(ext),
        isVideo: videoExts.includes(ext),
        path: URL.createObjectURL(file)
      }
      this.fileCacheList[uuid] = config
      return config
    },
    // 获取缓存附件
    getCacheFile(uuid) {
      const config = this.fileCacheList[uuid]
      if (config) return config
      else return false
    },
    // 获取当前登录用户信息
    async getBaseUserInfo() {
      if (this.isLogged && !getWithExpiry(ID_TOKEN_KEY)?.isExpired) {
        const [res1, res2] = await Promise.all([
          appServe.getUserInfo(),
          appServe.getUserCenterInfo()
        ])
        if (res1.success) {
          sessionStorage.setItem(ID_KEY, res1.data.id)
          sessionStorage.setItem("userInfo", res1.data)
          this.id = res1.data.id
          this.userInfo = res1.data
        }
        if (res2.success) {
          this.saveLoginKey({ type: res2.data.type?.toLowerCase() })
        }
      }
    },
    getUiStyle() {
      if (isZWEnv()) {
        ZWJSBridge.onReady(() => {
          ZWJSBridge.getUiStyle()
            .then((res) => {
              if (res.uiStyle == "elder") {
                this.uiStyle = "elder"
              } else {
                this.uiStyle = "normal"
              }
            })
            .catch((err) => {
              console.log("getUiStyle--err", err)
            })
        })
      } else {
        this.uiStyle = "normal"
      }
    }
  }
})
